import React, { useContext } from 'react';
import { AppBar, Box, Toolbar, useScrollTrigger } from '@mui/material';
import { HeaderMenu } from './HeaderMenu';
import { AuthContext } from './AuthContextProvider';
import { IFILogo } from './IFILogo';

const ElevationScroll = (props) => {
  const { children, window } = props;
  // Note that you normally won't need to set the window ref as useScrollTrigger
  // will default to window.
  // This is only being set here because the demo is in an iframe.
  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 0,
    target: window ? window() : undefined,
  });

  return React.cloneElement(children, {
    elevation: trigger ? 4 : 0,
  });
};

const IFIAppBar = (props) => {
  const { isLoggedIn, logOut } = useContext(AuthContext);

  return (
    <Box sx={{ flexGrow: 1 }}>
      <ElevationScroll {...props}>
        <>
        <AppBar>
          <Toolbar>
            <div style={{ flexGrow: 1 }}>
             <IFILogo size={{width:'80%'}}/>
            </div>
            {isLoggedIn && <HeaderMenu logOut={logOut} />}
          </Toolbar>
        </AppBar>
        <Toolbar/>
        </>
      </ElevationScroll>
      <Toolbar />
    </Box>
  );
};

export { IFIAppBar };
